import { group } from "console";
import { dropDownList } from "./Interface";

export const createFilterConfig = (dropDownList: dropDownList) => {
  return [
    {
      name: "posted_date",
      fieldType: "date",
      placeholder: "Posted Date",
      filterType: "search",
      label: "Posted Date",
    },
    {
      name: "position",
      fieldType: "text",
      placeholder: "Position",
      filterType: "search",
    },
    {
      name: "company",
      fieldType: "text",
      placeholder: "Company",
      filterType: "search",
    },
    {
      // CR (advert keyword): free-text search within the scraped advert text / job description.
      // Placed under Advanced Search (like other manage pages) rather than the main row.
      name: "advert_keyword",
      fieldType: "text",
      placeholder: "Advert keyword",
      filterType: "advSearch",
      label: "Advert keyword",
    },
    {
      // CR: Postal Code is now a multi-select dropdown (chips) so several codes can be searched together.
      name: "post_code",
      options: dropDownList.postCodes,
      fieldType: "multiSelect",
      placeholder: "Postal Code",
      filterType: "search",
    },
    {
      // km radius: optional distance around the selected postal code(s). When set,
      // results also include adverts in nearby postal codes within this many km.
      // Only takes effect when at least one postal code is selected.
      name: "km",
      options: [
        { value: 5, label: "5 km" },
        { value: 10, label: "10 km" },
        { value: 15, label: "15 km" },
        { value: 20, label: "20 km" },
        { value: 25, label: "25 km" },
        { value: 50, label: "50 km" },
      ],
      fieldType: "singleSelect",
      placeholder: "Radius (km)",
      filterType: "search",
      group: "two",
    },
    {
      name: "location",
      fieldType: "text",
      placeholder: "Location",
      filterType: "search",
      group: "two",
    },
    {
      name: "vat",
      fieldType: "text",
      placeholder: "VAT number",
      filterType: "search",
    },
    {
      name: "contactPerson",
      fieldType: "text",
      placeholder: "Contact person",
      filterType: "search",
    },
    {
      name: "phone",
      fieldType: "text",
      placeholder: "Phone no.",
      filterType: "search",
    },
    {
      name: "email",
      fieldType: "text",
      placeholder: "Email",
      filterType: "search",
    },
    {
      name: "source",
      fieldType: "text",
      placeholder: "Source",
      filterType: "search",
    },
    {
      name: "fromDate",
      fieldType: "date",
      placeholder: "From",
      group: "one",
      label: "From",
      filterType: "search",
    },
    {
      name: "toDate",
      fieldType: "date",
      placeholder: "To",
      group: "one", 
      label: "To",
      filterType: "search",
    },
  ];
};